import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { BsdirFeedback } from 'Douleutaras/types/bsdir';
import { RootState } from 'Douleutaras/redux/store';

const bsdirFeedbacksAdapter = createEntityAdapter<JSONApiDataObject<BsdirFeedback>>({
  selectId: item => item.id
});

export const bsdirFeedbacksSlice = createSlice({
  name: 'bsdirFeedbacks',
  initialState: bsdirFeedbacksAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<BsdirFeedback>),
  reducers: {
    bsdirFeedbacksAdded: (state, action) => {
      bsdirFeedbacksAdapter.setMany(state, action.payload);
    }
  }
});

export const bsdirFeedbacksSelectors = bsdirFeedbacksAdapter.getSelectors(
  (state: RootState) => state.bsdir.feedbacks);
export default bsdirFeedbacksSlice.reducer;
